import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { EventUtil } from "../../util/EventUtil";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";

interface ISubSpecialtyListItem {
    element: HTMLAnchorElement;
    text: string;
    url: string | null;
    value: string | null;
  }

export class SubSpecialtySelect extends Component {

    public static readonly SubSpecialtySelectInitEvent: string =
    "SubSpecialtySelect::InitEvent";

    private _lastValue: string | null = null;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {

        if (!(await this.attemptTagPatternMatch())){
          this.attemptUrlPatternMatch();
        }

        this._lastValue = this.subspecialty;

        this._element
          .querySelectorAll("[data-action='select subspecialty']")
          .forEach(
            el => el.addEventListener(
              "click",
              ev => this.handleSubSpecialtyClick(ev)));

        const mobileH1 =
          document.querySelector("h1[data-subspecialty-title='mobile']");

        if (mobileH1) {
          mobileH1.textContent = this.selectedElement ?
            this.selectedElement.textContent : this.getCurrentDropDownValue() ?
              this.getCurrentDropDownValue() : "";
        }

        this._element.dispatchEvent(
          EventUtil.createCustomEvent(
              SubSpecialtySelect.SubSpecialtySelectInitEvent,
              this.subspecialty));
    }

    public get subspecialty(): string {
        const active = this.selectedElement;

        return active ? active.dataset.value || "" : "";
      }

      public get subspecialtyName(): string {
        const active = this.selectedElement;

        return active ? active.textContent || "" : "";
      }

      private get subspecialties(): ReadonlyArray<ISubSpecialtyListItem> {
        return this.subspecialtyElements
          .map(element => {
            const text = (element.textContent || "").trim();
            const url = element.dataset.urlPattern || null;
            const value = element.dataset.value || null;

            return {
              element,
              text,
              url: url ? url.toLowerCase() : null,
              value
            };
          });
      }

    private async attemptTagPatternMatch(): Promise<boolean> {

      const context = await WyanokeUtil.loadContext(true);

      if (!context) {
        return false;
      }
      const docinfo = context.docinfo;

      if (!docinfo){
        return false;
      }

      const subspec = docinfo.primarysubspecialty;

      if (subspec) {
        const items = this.subspecialties;
        const item = items.find(
          s => s.text.toLowerCase().trim().replace(" ", "") ===
               subspec.toLocaleLowerCase().trim().replace(" ", "")
        );

        if (!item) {
          console.warn(
            "URL value not found in SubSpecialty list",
            subspec);

          return false;
        }

        this.setSelectedItem(item);

        return true;
      }

      return false;
    }

    private attemptUrlPatternMatch(): boolean {
        const match = window.location.pathname.split("/");

        // tslint:disable-next-line: no-magic-numbers
        if (match.length < 3)  {
            console.warn("No SubSpecialty in URL");

            return false;
        }

        // tslint:disable-next-line: no-magic-numbers
        const value = match[2];

        if (!value) {
          console.warn("No SubSpecialty in URL");

          return false;
        }

        const items = this.subspecialties;
        const item = items.find(s => s.text === value);

        if (!item) {
          console.warn(
            "URL value not found in SubSpecialty list",
            value);

          return false;
        }

        this.setSelectedItem(item);

        return true;
    }

    private get selectedElement(): HTMLAnchorElement | null {
        const selector = "[data-contains='subspecialties'] .active";

        return this._element.querySelector<HTMLAnchorElement>(selector);
      }

    private get subspecialtyElements(): ReadonlyArray<HTMLAnchorElement> {
        const selector = "[data-contains='subspecialties'] > a";
        const items = this._element.querySelectorAll<HTMLAnchorElement>(selector);

        return Array.from(items);
    }

    private handleSubSpecialtyClick(ev: Event): void {
        this.subspecialtyElements.forEach(item =>
            item.classList[item === ev.target ? "add" : "remove"]("active"));

        const selected = this.selectedElement;
        const subspecialtyId = this.subspecialty;

        $("[data-toggle='dropdown']", this._element)
            .dropdown("toggle")
            .text(selected ? selected.textContent || "" : "");

        if (subspecialtyId === this._lastValue) {
            ev.preventDefault();
            ev.stopPropagation();

            return;
        }

        this._lastValue = subspecialtyId;

        if (selected) {
            console.log("Navigating SubSpecialty Selected: " + selected.href);
            window.location.href = selected.href;
        }
    }

    private setSelectedItem(item: ISubSpecialtyListItem): void {
        const items = this.subspecialties;
        items.forEach(i => {
          const action = i.element === item.element ? "add" : "remove";
          i.element.classList[action]("active");
        });

        const toggle = this._element.querySelector("[data-toggle='dropdown']");
        if (toggle) {
          toggle.textContent = item.text;
        }
    }

    private getCurrentDropDownValue(): string | null {
        const toggle = this._element.querySelector("[data-toggle='dropdown']");

        return toggle ? toggle.textContent : "";
    }
}

ComponentFactory.registerComponent("SubSpecialtySelect", SubSpecialtySelect);
